function listgridJavascript() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
      link.addEventListener('click', function(event) {
          Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
          this.classList.add('active');
          if(this.classList.contains('listv')){
              document.getElementById('product-grid').classList.add('product-list');
              document.getElementById('product-grid').classList.remove('product-grid');
              document.getElementById('product-grid').classList.remove('product-gallery');
              document.getElementById('product-grid').classList.remove('product-twogrid');
              // Remove 'active' class from gridv on mobile
                if (window.innerWidth < 992) { 
                  document.querySelector(".gridv").classList.remove('active_mobile'); 
                }  
          }else if(this.classList.contains('gridv')){  
              document.getElementById('product-grid').classList.add('product-grid');
              document.getElementById('product-grid').classList.remove('product-list');
              document.getElementById('product-grid').classList.remove('product-gallery');
              document.getElementById('product-grid').classList.remove('product-twogrid');
          }else if(this.classList.contains('galleryv')){
              document.getElementById('product-grid').classList.add('product-gallery');
              document.getElementById('product-grid').classList.remove('product-list');
              document.getElementById('product-grid').classList.remove('product-grid');
              document.getElementById('product-grid').classList.remove('product-twogrid');
          }else if(this.classList.contains('twogrid')){
              document.getElementById('product-grid').classList.add('product-twogrid');
              document.getElementById('product-grid').classList.remove('product-gallery');
              document.getElementById('product-grid').classList.remove('product-list');
              document.getElementById('product-grid').classList.remove('product-grid');
          }
      });
  });
  };
  document.addEventListener("shopify:section:load", listgridJavascript);
  listgridJavascript();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// TIMER
setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
    }
  });
}

// Searchanise (snize) search widget — accessibility fix.
// The app sets an aria-label that differs from the visible text on
// controls that already show text — e.g. aria-label="View Products
// Tab" on a tab reading "Products", or aria-label="Sort options" on
// a button reading "Relevance". The accessible name then does not
// match the visible text (fails WCAG 2.5.3, Label in Name).
// Removing the redundant aria-label lets the visible text serve as
// the accessible name. Only controls that have visible text are
// touched, so icon-only controls keep the aria-label they depend on.
function fixSnizeAriaLabels() {
  var controls = document.querySelectorAll(
    '.snize [role="tab"][aria-label], .snize [role="button"][aria-label]'
  );
  controls.forEach(function (control) {
    if (control.textContent.trim()) {
      control.removeAttribute('aria-label');
    }
  });
}

// Searchanise (snize) search widget — nested interactive fix.
// Each result card is rendered as an <a class="snize-view-link"> that
// wraps the whole card, including an "Add to cart" <button>. A <button>
// nested inside an <a> is invalid HTML and nests an interactive element
// inside another interactive element (fails WCAG 4.1.2).
//
// We replace the wrapping <a> with a non-interactive <div> (keeping the
// same classes so the app's CSS still applies and nothing moves — grid
// and list keep their native layout). With no interactive ancestor, the
// "Add to cart" button is valid again. To keep the product reachable by
// keyboard and crawlers, the title text is wrapped in a real <a>, and a
// click handler on the card navigates for mouse users (clicks on the
// button or any other control are left alone). The new <div> is marked
// so the transform stays idempotent when the app re-renders its results.
function fixSnizeNestedButtons() {
  var links = document.querySelectorAll('a.snize-view-link');
  links.forEach(function (link) {
    var href = link.getAttribute('href');

    var card = document.createElement('div');
    card.className = link.className;
    card.classList.add('snize-card');
    card.dataset.snizeUnnested = 'true';
    if (href) card.dataset.snizeHref = href;

    // Preserve the app's other attributes (data-*, aria-label, etc.).
    Array.from(link.attributes).forEach(function (attr) {
      if (attr.name === 'href' || attr.name === 'class') return;
      card.setAttribute(attr.name, attr.value);
    });

    while (link.firstChild) card.appendChild(link.firstChild);
    link.parentNode.replaceChild(card, link);

    // Keep a real, focusable link on the title for keyboard users and SEO.
    var title = card.querySelector('.snize-title');
    if (href && title && !title.querySelector('a')) {
      var titleLink = document.createElement('a');
      titleLink.setAttribute('href', href);
      titleLink.className = 'snize-title-link';
      while (title.firstChild) titleLink.appendChild(title.firstChild);
      title.appendChild(titleLink);
    }

    // Mouse convenience: clicking the card (but not the button or any
    // other interactive control) navigates to the product.
    card.addEventListener('click', function (event) {
      if (event.target.closest('a, button, input, select, textarea, label')) return;
      if (card.dataset.snizeHref) window.location.href = card.dataset.snizeHref;
    });
  });
}

function fixSnizeAccessibility() {
  fixSnizeAriaLabels();
  fixSnizeNestedButtons();
}

document.addEventListener('DOMContentLoaded', function () {
  fixSnizeAccessibility();
  new MutationObserver(fixSnizeAccessibility).observe(document.body, {
    childList: true,
    subtree: true,
  });
});